import { Component, OnInit, ViewEncapsulation, ViewChild, ViewChildren, ElementRef, Input, Output } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal/modal.component';
import { FutureShape } from '../game/futureShape';
import {Observable} from 'rxjs/Rx';
import { TimerComponent } from '../game/timer.component';
import { Router, RouterModule } from '@angular/router';

import { GameComponentService } from '../game/gameComponent.service';
import { Subscription }   from 'rxjs/Subscription';


@Component({
  selector: 'game-header',
  templateUrl: './header-game.component.html',
  providers: [TimerComponent, FutureShape, RouterModule],
  encapsulation: ViewEncapsulation.None
})
export class HeaderGameComponent implements OnInit {

  constructor(public _srvc: GameComponentService, private _futureShape: FutureShape, private elRef:ElementRef, public router:Router) {
    //console.log("**************Header construct");
  }

  public disabled:boolean = false;
  public status:{isopen:boolean} = {isopen: false};
  public start:boolean = false;
  public yearNumber:string = "";

  public diff;
  public timerCount;
  
  GCSGameStarted: Subscription;
  GCStimer: Subscription;
  GCSgameOver: Subscription;
  GCSyearGameComplete: Subscription;

  public gameStarted: boolean = false;
  public gameOver: boolean = false;
  public yearGameComplete: boolean = false;
  public times: number = 100;   //start position for given year
  public timerDefault: string = "0:00";
  public progressStart: number = 33;   //start position for given year
  public progressEnd: number = 66;     //end position for given year
  public progressPercent:number = 0; //
  public progressExtra:string = "";

  public totalMet:boolean = false;

  public infoText: string = "";
  public has4:boolean = false;

  @ViewChild('gameBtn1') gameBtn1;
  @ViewChild('gameBtn2') gameBtn2;
  @ViewChild('gameBtn3') gameBtn3;
  @ViewChild('gameBtn4') gameBtn4;
  @ViewChild('endGameBtn') endGameBtn:ElementRef;
  @ViewChild('childModal') public childModal:ModalDirective;
  @ViewChild('progressbar') progress:ElementRef;
  @ViewChild('startSwitch') startSwitch;
  @ViewChild('timer') timerVal;
  @ViewChild('incompleteModal') public incompleteModal:ModalDirective;
  @ViewChild('infoModal') public infoModal:ModalDirective;
  @ViewChild('yearendModal') public yearendModal:ModalDirective;
  @ViewChild('welcomeModal') public welcomeModal:ElementRef;


  public toggled(open:boolean):void {
    //console.log('Dropdown is now: ', open);
    console.log('Status: ' + this.status.isopen);
  }

  public toggleDropdown($event:MouseEvent):void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
    console.log('status: ' + this.status.isopen);
  }

  public toggleBlock(){
    console.log("*******");
    console.log("toggleBlock");
    console.log("*******");
  }
  public toggleStart(){
    console.log("*******");
    console.log("this.start : " + this.start);
    console.log("*******");

    if (!this.start){
      // switch on
      console.log('toggle start');
      if (!this.gameStarted) {
        this.gameStarted;
        this._srvc.StartGame(true);
      }
      this.startSwitch.nativeElement.checked = this.start = true;
      this._srvc.StartYear(this.start);
      this.timerCount = this.timerVal.nativeElement.innerText;
      //this.elRef.nativeElement.querySelectorAll('.game-btn').classList.add('disabled');
      this.gameBtn1.nativeElement.classList.add('disabled');
      this.gameBtn2.nativeElement.classList.add('disabled');
      this.gameBtn3.nativeElement.classList.add('disabled');
      if (this.has4) this.gameBtn4.nativeElement.classList.add('disabled');
      
    }else{
      // bring up continue/cancel modal
      console.log('toggle end');
      this.startSwitch.nativeElement.checked = this.start = true;
      this.incompleteModal.show();
    }  

    if (this.gameOver) {
      this.startSwitch.nativeElement.checked = this.start = false;
      this.infoText = "This game is over. Please select another game from the menu.";
      this.infoModal.show();
    }
  }

  public endYearContinue(){
    this.startSwitch.nativeElement.checked = this.start = false;
    this.progressExtra = "";
    this.progress.nativeElement.style.width = this.progressEnd + "%";
    this.timerCount = this.timerVal.nativeElement.innerText;
    this._srvc.StartYear(this.start);
    this.incompleteModal.hide();
    this.gameBtn1.nativeElement.classList.remove('disabled');
    this.gameBtn2.nativeElement.classList.remove('disabled');
    this.gameBtn3.nativeElement.classList.remove('disabled');
    if (this.has4) this.gameBtn4.nativeElement.classList.remove('disabled');
  }



  public showChildModal():void {
    this.childModal.show();
  }

  public hideChildModal():void {
    this.childModal.hide();
  }

  public timerLength(event){
    var timeLeft = this.times - (this.times * event);
    if (timeLeft <= 60 && timeLeft > 0) {
      if (timeLeft % 4 == 0)
        this.progressExtra = "blank";
      else
        this.progressExtra = "warning";
    }
    else {
      this.progressExtra = "";
    }
    
    this.progressPercent = this.progressStart + ((this.progressEnd-this.progressStart)*event);
    this.progress.nativeElement.style.width = this.progressPercent + "%";
  }

  public timerChange(event){
    this.start = this.startSwitch.nativeElement.checked = event;
    //this.timerVal.nativeElement.innerText;


    this.infoText = "Time is up! Your results will be recorded as they are currently displayed.";
    this.infoModal.show();
    this._srvc.StartYear(this.start);

    this.gameBtn1.nativeElement.classList.remove('disabled');
    this.gameBtn2.nativeElement.classList.remove('disabled');
    this.gameBtn3.nativeElement.classList.remove('disabled');
    if (this.has4) this.gameBtn4.nativeElement.classList.remove('disabled');
  }

  public welcomeClick(){
    //alert('click');
    //console.log(this.welcomeModal);
    this.welcomeModal.nativeElement.hidden = true;
  }

  public helpClick(event){
    this.welcomeModal.nativeElement.hidden = false;
  }

  ngOnInit() {
    //console.log("header-game.component : ngOnInit");

    this.GCSGameStarted = this._srvc.GameStarted$.subscribe(
			res => {
				console.log("Game GameStarted Update: " + res);
				this.gameStarted = res;
			},
			err => console.log("GameStarted error: " + err)
		);

    this.GCStimer = this._srvc.Timer$.subscribe(
      res => {
        //console.log("head-game Timer Update: ");
        //console.log(res);
        // this.startSwitch.nativeElement.checked = false;
        // this.start = false;
        this.times = res.Length;
        this.progressStart = res.From;
        this.progressEnd = res.To;
        this.yearNumber = res.Year;
        this.timerDefault = this._srvc.secondsToTime(this.times);
        this.start = this.startSwitch.nativeElement.checked = false;
        this.progress.nativeElement.style.width = this.progressStart + "%";
      },
      err => console.log("sub error: " + err),
    );
    this.GCSgameOver = this._srvc.GameOver$.subscribe(
      res => {
        //console.log("head-game GameOver Update: " + res);
        // this.startSwitch.nativeElement.checked = false;
        // this.start = false;
        this.gameOver = res;
        if (this.gameOver) {
          this.gameBtn1.nativeElement.classList.remove('disabled');
          this.gameBtn2.nativeElement.classList.remove('disabled');
          this.gameBtn3.nativeElement.classList.remove('disabled');
          if (this.has4) this.gameBtn4.nativeElement.classList.remove('disabled');          
        }
        console.log("header gameOver: " + this.gameOver);
      },
      err => console.log("sub error: " + err),
    );
    this.GCSyearGameComplete = this._srvc.YearGameCompleted$.subscribe(
      res => {
        //console.log("head-game YearGameCompleted Update: " + res);
        this.yearGameComplete = res;
      },
      err => console.log("sub error: " + err),
    );
  }

  ngOnDestroy() {
    try {
      this.GCSGameStarted.unsubscribe();
      this.GCStimer.unsubscribe();
      this.GCSgameOver.unsubscribe();
      this.GCSyearGameComplete.unsubscribe();
		}
		catch (ex) {
		
		}      
  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/header-game.component.ts